"use strict";

exports.__esModule = true;
exports.constraintRegexp = void 0;
const constraintRegexp = /<([A-z][A-z0-9]*)>/g;
exports.constraintRegexp = constraintRegexp;